import { Col, Row } from "antd";
import styles from "./Jobs.module.css";
import { GoClock, GoStack } from "react-icons/go";
import { TbCurrencyDollar } from "react-icons/tb";

const Jobs = ({ data, onChange }) => {
  const details = ["sub", "sector", "salary", "type"];
  const icons = {
    sector: <GoStack />,
    salary: <TbCurrencyDollar />,
    type: <GoClock />,
  };

  return (
    <>
      <div className={styles.content_wrap}>
        <div className={styles.content}>
          <div className={styles.title}>Recent Job offerings</div>
          <div>
            <Row gutter={[8, 8]} className={styles.row}>
              {data?.jobs?.map((item) => {
                return (
                  <Col xs={24} sm={24} md={24} lg={12} xl={12} id="graph_col">
                    <div className={styles.box}>
                      <div>
                        <img
                          className={styles.img_wrap}
                          src={item.img}
                          alt={"job profile"}
                        />
                      </div>
                      <div>
                        <div className={styles.name}>{item.name}</div>
                        <div className={styles.details}>
                          {details.map((key) => {
                            return (
                              item[key] && (
                                <div>
                                  {icons[key] && icons[key]}
                                  {item[key]}
                                </div>
                              )
                            );
                          })}
                        </div>
                        <div className={styles.tags_wrap}>
                          {item?.tags?.map((tag) => (
                            <div>{tag}</div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default Jobs;
